module.exports = __webpack_public_path__ + "static/mask-3-c9901712210d8c8ebf46062a5c385dd0.png";